module.exports = "images/-10.49ed8cc7.png";